import React, { useState } from "react";
import { Typography, Checkbox, makeStyles, Divider } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import Grid from "../../components/Grid";
import Button from "../../components/Button";
import { Select, DateInput } from "../../components/Form";
import { Card, CardContent, CardActions } from "../../components/Card";

export default function StatisticalTable() {
  const history = useHistory();
  const [selectData, setSelectData] = useState([])
  const [newData, setNewData] = useState({
    auctionQuotesArray: [
      {
        label: "平均拍賣行情",
        value: "AVERAGEAUCTIONPRICE",
      },
      {
        label: "平均成交行情",
        value: "AVERAGETRANSACTIONPRICE",
      },
      {
        label: "平均拍賣拍次",
        value: "AVERAGETRANSACTIONNUMBER",
      },
      {
        label: "平均拍賣類型",
        value: "AVERAGETRANSACTIONTYPE",
      },
      {
        label: "平均拍賣件數",
        value: "AVERAGENUMBEROFAUCTIONS",
      },
    ],
    auctionQuotes: "AVERAGEAUCTIONPRICE",
    auctionQuotesObject: {
      label: "平均拍賣行情",
      value: "AVERAGEAUCTIONPRICE",
    },
    rangeArray: [
      {
        label: "全省",
        value: "WHOLEPROVINCE",
      },
      {
        label: "臺灣台北地方法院",
        value: "臺灣台北地方法院",
      },
      {
        label: "臺灣新北地方法院",
        value: "臺灣新北地方法院",
      },
      {
        label: "臺灣士林地方法院",
        value: "臺灣士林地方法院",
      },
      {
        label: "臺灣桃園地方法院",
        value: "臺灣桃園地方法院",
      },
      {
        label: "臺灣新竹地方法院",
        value: "臺灣新竹地方法院",
      },
      {
        label: "臺灣苗栗地方法院",
        value: "臺灣苗栗地方法院",
      },
      {
        label: "臺灣臺中地方法院",
        value: "臺灣臺中地方法院",
      },
      {
        label: "臺灣南投地方法院",
        value: "臺灣南投地方法院",
      },
      {
        label: "臺灣彰化地方法院",
        value: "臺灣彰化地方法院",
      },
      {
        label: "臺灣雲林地方法院",
        value: "臺灣雲林地方法院",
      },
      {
        label: "臺灣嘉義地方法院",
        value: "臺灣嘉義地方法院",
      },
      {
        label: "臺灣臺南地方法院",
        value: "臺灣臺南地方法院",
      },
      {
        label: "臺灣橋頭地方法院",
        value: "臺灣橋頭地方法院",
      },
      {
        label: "臺灣高雄地方法院",
        value: "臺灣高雄地方法院",
      },
      {
        label: "臺灣屏東地方法院",
        value: "臺灣屏東地方法院",
      },
      {
        label: "臺灣臺東地方法院",
        value: "臺灣臺東地方法院",
      },
      {
        label: "臺灣花蓮地方法院",
        value: "臺灣花蓮地方法院",
      },
      {
        label: "臺灣宜蘭地方法院",
        value: "臺灣宜蘭地方法院",
      },
      {
        label: "臺灣基隆地方法院",
        value: "臺灣基隆地方法院",
      },
      {
        label: "臺灣澎湖地方法院",
        value: "臺灣澎湖地方法院",
      },
      {
        label: "福建金門地方法院",
        value: "福建金門地方法院",
      },
      {
        label: "福建連江地方法院",
        value: "福建連江地方法院",
      },
    ],
    range: "WHOLEPROVINCE",
    rangeObject: {
      label: "全省",
      value: "WHOLEPROVINCE",
    },
    statisticsTimeStart: null,
    statisticsTimeEnd: null,
    typeLandArray: [
      {
        name: "土地",
        value: 11,
        type: "LAND",
      },
      {
        name: "建物",
        value: 50,
        type: "CONSTRUCTIONSITE",
      },
      {
        name: "田地",
        value: 34,
        type: "FIELD",
      },
      {
        name: "旱地",
        value: 20,
        type: "DRYLAND",
      },
      {
        name: "林地",
        value: 42,
        type: "WOODLAND",
      },
      {
        name: "原住民",
        value: 10,
        type: "ABORIGINAL",
      },
      {
        name: "道路用地",
        value: 16,
        type: "ROADLAND",
      },
    ],
    typeBuildArray: [
      {
        name: "透天",
        value: 30,
        type: "ALLOVERTHESKY",
      },
      {
        name: "樓店",
        value: 22,
        type: "SHOP",
      },
      {
        name: "廠房",
        value: 24,
        type: "FACTORYBUILD",
      },
      {
        name: "平房",
        value: 26,
        type: "BUNGALOW",
      },
      {
        name: "地下室",
        value: 8,
        type: "BASEMENT",
      },
    ],
    typeInternalArray: [
      {
        name: "華廈",
        value: 14,
        type: "HUAXIA",
      },
      {
        name: "公寓",
        value: 32,
        type: "APARTMENTS",
      },
      {
        name: "套房",
        value: 30,
        type: "SUITE",
      },
      {
        name: "辦公",
        value: 36,
        type: "OFFICE",
      },
      {
        name: "含車位",
        value: 25,
        type: "INCLUDINGPARKINGSPACE",
      },
    ],
    statisticsType: "HUAXIA",
  });

  function changeDataListener(key, v) { }
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }

  const useStyles = makeStyles({
    DocumentContainerRow: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
    },
    DocumentContainerColumn: {
      flexDirection: "column",
    },
    DocumentContainerCenter: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    },
  });
  const classes = useStyles();
  return (
    <Card>
      <CardContent>
        <Grid container spacing={1}>
          <Grid container item spacing={1}>
            <Grid
              container
              item
              spacing={1}
              classes={{ root: classes.DocumentContainerColumn }}
            >
              <Grid item>
                <Typography color="primary">統計分析數據</Typography>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Select
                  placeholder={"請選擇拍賣行情"}
                  items={newData.auctionQuotesArray}
                  value={
                    newData.auctionQuotesObject.value
                      ? newData.auctionQuotesObject
                      : null
                  }
                  onChange={(e, value) => {
                    if (value) {
                      changeData("auctionQuotes", value.value);
                      changeData("auctionQuotesObject", value, true);
                    } else {
                      changeData("auctionQuotes", "AVERAGEAUCTIONPRICE");
                      changeData(
                        "auctionQuotesObject",
                        {
                          label: "平均拍賣行情",
                          value: "AVERAGEAUCTIONPRICE",
                        },
                        true
                      );
                    }
                  }}
                  fullWidth
                />
              </Grid>
            </Grid>
            <Grid
              container
              item
              spacing={1}
              classes={{ root: classes.DocumentContainerColumn }}
            >
              <Grid item>
                <Typography color="primary">分析範圍</Typography>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Select
                  placeholder={"請選擇範圍"}
                  items={newData.rangeArray}
                  value={newData.rangeObject.value ? newData.rangeObject : null}
                  onChange={(e, value) => {
                    if (value) {
                      changeData("range", value.value);
                      changeData("rangeObject", value, true);
                    } else {
                      changeData("range", "WHOLEPROVINCE");
                      changeData(
                        "rangeObject",
                        {
                          label: "全省",
                          value: "WHOLEPROVINCE",
                        },
                        true
                      );
                    }
                  }}
                  fullWidth
                />
              </Grid>
            </Grid>
            <Grid container item spacing={1}>
              <Grid item xs={12} sm={3}>
                <Typography color="primary">統計期間</Typography>
                <DateInput
                  inputVariant="outlined"
                  format="yyyy年MM月dd日"
                  value={newData.statisticsTimeStart}
                  onChange={(v) => changeData("statisticsTimeStart", v, true)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography color="primary">至</Typography>
                <DateInput
                  inputVariant="outlined"
                  format="yyyy年MM月dd日"
                  value={newData.statisticsTimeEnd}
                  minDate={newData.statisticsTimeStart}
                  onChange={(v) => changeData("statisticsTimeEnd", v, true)}
                  fullWidth
                />
              </Grid>
            </Grid>
            <Grid
              container
              item
              spacing={1}
              classes={{ root: classes.DocumentContainerColumn }}
            >
              <Typography color="primary">統計類別</Typography>
              <Grid item classes={{ root: classes.DocumentContainerRow }}>
                {newData.typeLandArray.map((item, index) => {
                  return (
                    <Grid
                      item
                      xs={6}
                      sm={1}
                      classes={{ root: classes.DocumentContainerCenter }}
                      key={index}
                    >
                      <Checkbox
                        color="primary"
                        checked={Boolean(selectData.find((item2) => item2.name === item.name))}
                        onChange={() => {
                          const has = selectData.find((selectItem) => selectItem.name === item.name)
                          if (has) {
                            setSelectData((e) => e.filter((i) => i.name !== item.name))
                          }
                          else {
                            setSelectData((e) => [...e, item])
                          }

                          changeData("selectData", item.name, true)
                        }}
                      />
                      <Typography color="primary">{item.name}</Typography>
                    </Grid>
                  );
                })}
              </Grid>
              <Grid item classes={{ root: classes.DocumentContainerRow }}>
                {newData.typeBuildArray.map((item, index) => {
                  return (
                    <Grid
                      item
                      xs={6}
                      sm={1}
                      classes={{ root: classes.DocumentContainerCenter }}
                      key={index}
                    >
                      <Checkbox
                        color="primary"
                        checked={Boolean(selectData.find((item2) => item2.name === item.name))}
                        onChange={() => {
                          const has = selectData.find((selectItem) => selectItem.name === item.name)
                          if (has) {
                            setSelectData((e) => e.filter((i) => i.name !== item.name))
                          }
                          else {
                            setSelectData((e) => [...e, item])
                          }

                          changeData("selectData", item.name, true)
                        }}
                      />
                      <Typography color="primary">{item.name}</Typography>
                    </Grid>
                  );
                })}
              </Grid>
              <Grid item classes={{ root: classes.DocumentContainerRow }}>
                {newData.typeInternalArray.map((item, index) => {
                  return (
                    <Grid
                      item
                      xs={6}
                      sm={1}
                      classes={{ root: classes.DocumentContainerCenter }}
                      key={index}
                    >
                      <Checkbox
                        color="primary"
                        checked={Boolean(selectData.find((item2) => item2.name === item.name))}
                        onChange={() => {
                          const has = selectData.find((selectItem) => selectItem.name === item.name)
                          if (has) {
                            setSelectData((e) => e.filter((i) => i.name !== item.name))
                          }
                          else {
                            setSelectData((e) => [...e, item])
                          }

                          changeData("selectData", item.name, true)
                        }}
                      />
                      <Typography color="primary">{item.name}</Typography>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardActions>
        <Button
          variant="outlined"
          color="primary"
          onPress={() => history.push(`/console/statistical-results`,
            {
              auctionQuotesObject: newData.auctionQuotesObject, rangeObject: newData.rangeObject,
              selectData,
            })}
        >
          進行數據分析
        </Button>
      </CardActions>
    </Card>
  );
}
